import { reduxKey } from './constants';
import { updateSubmittingState, updateSubmitErrorString } from './actionCreators';
import { handleActions } from 'redux-actions';
import { CommissionState } from './types';

const actionHandlers = handleActions<CommissionState, any>(
  {
    [`${updateSubmittingState}`]: (state, action: ReturnType<typeof updateSubmittingState>) => ({
      ...state,
      submittingState: action.payload.submittingState,
    }),
    [`${updateSubmitErrorString}`]: (
      state,
      action: ReturnType<typeof updateSubmitErrorString>
    ) => ({
      ...state,
      submitErrorString: action.payload.submitErrorString,
    }),
  },
  {
    submittingState: 'idle',
    submitErrorString: '',
  }
);

const reducers = {
  [reduxKey as string]: actionHandlers,
};

export default reducers;
